import {
  CommandBarButton,
  ContextualMenuItem,
  ICommandBarItemProps,
  IComponentAsProps,
  IContextualMenuItemProps
} from "@fluentui/react";
import { useNavigate } from "react-router-dom";

export function CustomButton(
  props: IComponentAsProps<ICommandBarItemProps>
): JSX.Element {
  const navigate = useNavigate();

  if (props.to) {
    const WrappedButton = () => (
      <CommandBarButton
        {...(props as any)}
        onClick={() => {
          // eslint-disable-next-line react/prop-types
          if (props.onClick) {
            // eslint-disable-next-line react/prop-types
            props.onClick();
          }
          // eslint-disable-next-line react/prop-types
          navigate(props.to);
        }}
      />
    );

    return <WrappedButton />;
  } else {
    return <CommandBarButton {...(props as any)} />;
  }
}

export function MenuButton(
  props: IComponentAsProps<ICommandBarItemProps>
): JSX.Element {
  return (
    <CommandBarButton
      {...(props as any)}
      iconProps={{
        iconName: props.isMenuOpen ? "ChromeClose" : "GlobalNavButton"
      }}
      className="ms-hiddenLgUp"
    />
  );
}

export function CustomMenuItem(props: IContextualMenuItemProps): JSX.Element {
  const navigate = useNavigate();

  if (props.item.to) {
    const item = props.item;
    item.onClick = () => {
      if (item?.data?.currentBU.length > 0) {
        item.data.selectBU(...item.data.currentBU);
      }

      navigate(props.item.to);
    };
    const WrappedMenuItem = () => <ContextualMenuItem {...props} item={item} />;

    return <WrappedMenuItem />;
  } else {
    return <ContextualMenuItem {...props} item={props.item} />;
  }
}
